const TEXT_START_X = 16
const TEXT_START_Y = 16

export default class TextState extends Phaser.State {
  init (levelIndex) {
    this.levelIndex = levelIndex

    const currentLevelString = window.localStorage.getItem('level')
    if (!currentLevelString || levelIndex > parseInt(currentLevelString)) {
      window.localStorage.setItem('level', `${levelIndex}`)
    }
  }

  create (game) {
    if (this.levelIndex >= LEVEL_TEXT.length) {
      this.state.start('level', true, false, this.levelIndex)
      return
    }

    this.gameText = LEVEL_TEXT[this.levelIndex]

    this.currentPage = 0

    this.shownText = this.add.bitmapText(16, 16, 'monospace', '', 9)
    this.animating = false
    this.animatingText = []
    this.tweens = this.animatePage()
    this.setupKeyboard()
    this.active = true
  }

  animatePage () {
    const pageText = this.gameText[this.currentPage]
    const splitText = pageText.split('\n')
    const tweens = []
    this.animating = true
    this.animatingText = []

    for (let i in splitText) {
      const line = splitText[i]
      const text = this.add.bitmapText(
        TEXT_START_X, TEXT_START_Y + i * TILE_HEIGHT, 'monospace', line, 9
      )
      text.alpha = 0

      const tween = this.game.add.tween(text)
      tween.to({alpha: 1}, 200, Phaser.Easing.Linear.None, false, 1000)

      if (tweens.length > 0) tweens[tweens.length - 1].chain(tween)

      this.animatingText.push(text)
      tweens.push(tween)
    }

    const ellipsisText = this.add.bitmapText(
      TEXT_START_X, TEXT_START_Y + splitText.length * TILE_HEIGHT, 'monospace', '...', 9
    )
    ellipsisText.alpha = 0

    this.ellipsisTween = this.game.add.tween(ellipsisText)
    this.ellipsisTween.to({alpha: 1}, 1000, Phaser.Easing.Linear.None, false, 1000, -1, true)

    tweens[tweens.length - 1].chain(this.ellipsisTween)
    tweens[tweens.length - 1].onComplete.add(() => { this.animating = false })
    tweens[0].start()

    return tweens
  }

  setupKeyboard () {
    const onEnter = () => {
      if (this.active) {
        if (this.animating) {
          for (let tween of this.tweens) {
            tween.stop(true)
          }

          for (let text of this.animatingText) {
            text.alpha = 1
          }

          this.animating = false

          return
        }

        this.fadeOut()

        if (this.currentPage < this.gameText.length - 1) {
          this.currentPage++
          this.tweens = this.animatePage()
        } else {
          this.active = false
          this.game.input.keyboard.reset()
          this.state.start('level', true, false, this.levelIndex)
        }
      }
    }

    const enterKey = this.game.input.keyboard.addKey(Phaser.Keyboard.ENTER)
    enterKey.onDown.add(() => { onEnter() })
    const mKey = this.game.input.keyboard.addKey(Phaser.Keyboard.M)
    mKey.onDown.add(() => { onEnter() })
  }

  fadeIn () {
    const graphic = this.game.add.graphics()
    graphic.beginFill(0x000000, 1)
    graphic.drawRect(0, 0, this.game.width, this.game.height)
    graphic.endFill()
    graphic.alpha = 1
    this.game.add.tween(graphic).to({alpha: 0}, 500, Phaser.Easing.Linear.None, true)
  }

  fadeOut () {
    const graphic = this.game.add.graphics()
    graphic.beginFill(0x000000, 1)
    graphic.drawRect(0, 0, this.game.width, this.game.height)
    graphic.endFill()
    graphic.alpha = 0
    const tween = this.game.add.tween(graphic).to({alpha: 1}, 500, Phaser.Easing.Linear.None, true)

    return tween
  }
}
